import React from 'react'
import { Route, IndexRoute } from 'react-router'
import * as Views from './views'
import Layout from './layout'

const Routes = (
  <Route path="home" component={Layout}>
    <IndexRoute component={Views.Home} />
  </Route>
)

export default Routes
